// extracted by mini-css-extract-plugin
export default {"customMenu":"MyArticlesDropdownMenu_customMenu__NTdkA","dropdownItem":"MyArticlesDropdownMenu_dropdownItem__jnzAG"};